export function formatYmdHmsZh(value: string | Date) {
	const date = typeof value === 'string' ? new Date(value) : value;

	if (Number.isNaN(date.getTime())) {
		return '';
	}

	return date.toLocaleString('zh-CN', { hour12: false });
}
